"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmbClientOrderBatteriesPackingType = exports.SmbClientOrderFreightType = exports.SmbClientOrderDeclaredAsDangerous = void 0;
var SmbClientOrderDeclaredAsDangerous;
(function (SmbClientOrderDeclaredAsDangerous) {
    SmbClientOrderDeclaredAsDangerous["INVALID"] = "INVALID";
    SmbClientOrderDeclaredAsDangerous["EVERYTHING"] = "EVERYTHING";
    SmbClientOrderDeclaredAsDangerous["PARTIAL"] = "PARTIAL";
    SmbClientOrderDeclaredAsDangerous["NOTHING"] = "NOTHING";
    SmbClientOrderDeclaredAsDangerous["UNSURE"] = "UNSURE";
})(SmbClientOrderDeclaredAsDangerous = exports.SmbClientOrderDeclaredAsDangerous || (exports.SmbClientOrderDeclaredAsDangerous = {}));
var SmbClientOrderFreightType;
(function (SmbClientOrderFreightType) {
    SmbClientOrderFreightType["INVALID"] = "INVALID";
    SmbClientOrderFreightType["DOOR_TO_DOOR"] = "DOOR_TO_DOOR";
    SmbClientOrderFreightType["DOOR_TO_PORT"] = "DOOR_TO_PORT";
    SmbClientOrderFreightType["PORT_TO_DOOR"] = "PORT_TO_DOOR";
    SmbClientOrderFreightType["PORT_TO_PORT"] = "PORT_TO_PORT";
})(SmbClientOrderFreightType = exports.SmbClientOrderFreightType || (exports.SmbClientOrderFreightType = {}));
var SmbClientOrderBatteriesPackingType;
(function (SmbClientOrderBatteriesPackingType) {
    SmbClientOrderBatteriesPackingType["INVALID"] = "INVALID";
    SmbClientOrderBatteriesPackingType["PACKED_LOOSE"] = "PACKED_LOOSE";
    SmbClientOrderBatteriesPackingType["PACKED_WITH_EQUIPMENT"] = "PACKED_WITH_EQUIPMENT";
    SmbClientOrderBatteriesPackingType["CONTAINED_IN_EQUIPMENT"] = "CONTAINED_IN_EQUIPMENT";
    SmbClientOrderBatteriesPackingType["CONTAINED_IN_BATTERY_POWERED_VEHICLE"] = "CONTAINED_IN_BATTERY_POWERED_VEHICLE";
})(SmbClientOrderBatteriesPackingType = exports.SmbClientOrderBatteriesPackingType || (exports.SmbClientOrderBatteriesPackingType = {}));
//# sourceMappingURL=SMBClientOrder.js.map